import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CustomerApi } from '_api';
import { handleError, handleResponse } from '_helpers/api';

export const getPaymentMethods = createAsyncThunk(
  'billing/getPaymentMethods',
  async function ({ customerId }, { rejectWithValue }) {
    try {
      const response = await CustomerApi.getPaymentMethods({ customerId });
      return handleResponse(response);
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

export const createPaymentMethod = createAsyncThunk(
  'billing/createPaymentMethod',
  async function ({ customerId, body }, { dispatch, rejectWithValue }) {
    try {
      await CustomerApi.createPaymentMethod({ customerId, body });
      dispatch(getPaymentMethods({ customerId }));
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const billingSlice = createSlice({
  name: 'billing',
  initialState: {
    paymentMethods: {
      data: [],
      error: null,
      loading: false,
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethods.pending, (state) => {
        state.paymentMethods.data = [];
        state.paymentMethods.error = null;
        state.paymentMethods.loading = true;
      })
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        state.paymentMethods.data = action.payload;
        state.paymentMethods.loading = false;
      })
      .addCase(getPaymentMethods.rejected, (state, action) => {
        state.paymentMethods.error = action.payload;
        state.paymentMethods.loading = false;
      });

    builder
      .addCase(createPaymentMethod.pending, (state) => {
        state.paymentMethods.error = null;
        state.paymentMethods.loading = true;
      })
      .addCase(createPaymentMethod.rejected, (state, action) => {
        state.paymentMethods.error = action.payload;
        state.paymentMethods.loading = false;
      });
  },
});

export default billingSlice.reducer;
